import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectTotalReports = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.totalUserReports;
};
export const selectDateFrom = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.dateFrom;
};
export const selectDateTo = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.dateTo;
};
export const selectUsers = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.totalUsers;
};
export const selectReportUid = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.reportUid;
};
export const selectReportTitles = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.reportTitles;
};
export const selectFilterWorksheetStatus = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.filterWorksheetStatus;
};
export const selectReportType = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.reportType;
};
export const selectJobPacks = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.jobPacks;
};
export const selectJobID = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.reportJobID;
};
export const selectSelectedRowIndex = ({ SubmittedReports_reducer }) => {
    return SubmittedReports_reducer.selectedRowIndex;
};
export const selectJobPackIDs = createSelector(
    [selectJobPacks],
    totalJobPacks => {
        if (totalJobPacks === false || totalJobPacks === null) {
            return [];
        }
        let ids = Object.keys(totalJobPacks).map(e => {
            return {
                id: e,
                job_type: totalJobPacks[e].profile.job_type,
                job_name: totalJobPacks[e].profile.job_name
            };
        });
        return ids;
    }
);
export const selectUserNames = createSelector(
    [selectUsers],
    users => {
        if (users === false) {
            return [];
        }
        return Object.keys(users).map(uid => {
            const user = users[uid];
            const name = _.get(user, "profile.first_name") + " " + _.get(user, "profile.last_name");
            return { name: name, uid };
        });
    }
);

export const selectDataForTable = createSelector(
    [
        //selectTotalReports,
        selectUsers,
        selectDateFrom,
        selectDateTo,
        selectReportUid,
        selectFilterWorksheetStatus,
        selectReportType,
        selectJobID
    ],
    (totalReports, dateFrom, dateTo, uid, status, reportType, jobID) => {
        if (totalReports === false) {
            return [];
        }
        if (dateTo === false) {
            dateTo = dateFrom;
        }
        let reports = [];
        let selectedReports = [];
        Object.keys(totalReports).map(e => {
            if (totalReports[e].reports !== undefined) {
                reports.push({ uprn: e, userReports: totalReports[e].reports });
            }
            return true;
        });

        //OLD WAY TO FILTER
        // _.filter(reports, e => {
        //     let uprn = e.uprn;
        //     Object.keys(e.userReports).map(f => {
        //         if (f !== "holiday_request") {
        //             _.filter(e.userReports[f], g => {
        //                 selectedReports.push({
        //                     uprn: uprn,
        //                     report_type: f,
        //                     timestamp: g.timestamp,
        //                     user_name: g.user_name,
        //                     worksheet_status: g.worksheet_status,
        //                     subject_name: g.subject_name,
        //                     subject_child: g.subject_child
        //                 });
        //             });
        //         }
        //         return true;
        //     });
        // });

        //NEWER WAY -- STILL NEEDS WORK
        Object.keys(reports).map(e => {
            let uprn = reports[e].uprn;
            Object.keys(reports[e].userReports).map(f => {
                if (f !== "holiday_request") {
                    Object.keys(reports[e].userReports[f]).map(g => {
                        selectedReports.push({
                            uprn: uprn,
                            report_type: f,
                            timestamp: reports[e].userReports[f][g].timestamp,
                            user_name: reports[e].userReports[f][g].user_name,
                            worksheet_status: reports[e].userReports[f][g].worksheet_status,
                            subject_name: reports[e].userReports[f][g].subject_name,
                            subject_child: reports[e].userReports[f][g].subject_child
                        });
                        return true;
                    });
                }
                return true;
            });
            return true;
        });
        if (uid) {
            selectedReports = _.filter(selectedReports, e => {
                if (e.uprn === uid) {
                    return e;
                }
            });
        }
        if (reportType) {
            selectedReports = _.filter(selectedReports, e => {
                if (e.report_type === reportType) {
                    return e;
                }
            });
        }
        if (status !== false) {
            selectedReports = filterByStatus(selectedReports, status);
        }
        if (dateTo !== false && dateFrom !== false) {
            dateFrom = new Date(dateFrom.setHours(0));
            selectedReports = filterByDate(selectedReports, dateFrom, dateTo);
        }
        if (jobID) {
            selectedReports = _.filter(selectedReports, e => {
                if (e.subject_child === jobID) {
                    return e;
                } else if (jobID === "standalone" && e.subject_name === "reports") {
                    return e;
                }
            });
        }
        let sortedSelectedReports = selectedReports.sort((a, b) => {
            a = new moment(a.timestamp, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
            b = new moment(b.timestamp, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
            return a.diff(b);
        });

        return sortedSelectedReports.reverse();
    }
);
function filterByDate(orderedDailyReports, dateFrom, dateTo) {
    return _.filter(orderedDailyReports, e => {
        let dateParts = e.timestamp.split("-");
        let current = new Date(dateParts[2].split(" ", 1), dateParts[1] - 1, dateParts[0]);

        return current >= dateFrom && current <= dateTo;
    });
}

function filterByStatus(orderedDailyReports, status) {
    return _.filter(orderedDailyReports, e => {
        if (status === null) {
            if (e.worksheet_status === "" || e.worksheet_status === undefined) {
                return e;
            }
        } else if (e.worksheet_status === status) {
            return e;
        }
    });
}
